import { FigureVarDataDto, isFigureVarDataDto } from "./FigureVarDataDto";

/**
 * Represents the data for a single axis within a figure.
 */
export interface FigureAxisDataDto {
  id: string;
  axisType: string;
  properties: FigureVarDataDto[];
}

/**
 * Type guard to check if an object is a FigureAxisDataDto value.
 *
 * @param obj - The object to check.
 * @returns True when the value matches the figure axis data shape.
 */
export const isFigureAxisDataDto = (obj: unknown): obj is FigureAxisDataDto => {
  if (typeof obj !== "object" || obj === null) {
    return false;
  }
  const chkObj = obj as FigureAxisDataDto;
  if (typeof chkObj.id !== "string") {
    return false;
  }
  if (typeof chkObj.axisType !== "string") {
    return false;
  }
  if (!Array.isArray(chkObj.properties)) {
    return false;
  }
  if (chkObj.properties.some((property) => !isFigureVarDataDto(property))) {
    return false;
  }
  return true;
};
